import { ITab } from '@/shared/Tabs/tabs.types.ts'
import { TParameterCardTab } from './parameters.types.ts'

const cardTabs: ITab<TParameterCardTab>[] = [
  { title: 'Переменные', id: 'parameterTab' },
  { title: 'Вычисляемые переменные', id: 'parameterCalculatedTab' },
]

const parameterPageConstants = { cardTabs }
export default parameterPageConstants
